import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "types";
import { initialState } from "./initialState";

const selectDomain = (state: RootState) =>
  state.manufacturerModelState || initialState;

export const selectManufacturerModelManufacturerFilter = createSelector(
  [selectDomain],
  (manufacturerModelState) => manufacturerModelState.manufacturerFilter
);

export const selectManufacturerModelMasterModelFilter = createSelector(
  [selectDomain],
  (manufacturerModelState) => manufacturerModelState.masterModelFilter
);

export const selectManufacturerModelYearFilter = createSelector(
  [selectDomain],
  (manufacturerModelState) => manufacturerModelState.yearFilter
);

export const selectManufacturerModelLicensingWeightFilter = createSelector(
  [selectDomain],
  (manufacturerModelState) => manufacturerModelState.licensingWeightFilter
);

export const selectManufacturerModelsLoading = createSelector(
  [selectDomain],
  (manufacturerModelState) => manufacturerModelState.loading
);

export const selectManufacturerModelsList = createSelector(
  [selectDomain],
  (manufacturerModelState) => manufacturerModelState.list
);

export const selectIsAddModalOpen = createSelector(
  [selectDomain],
  (manufacturerModelState) => manufacturerModelState.isAddModalOpen
);

export const selectManufacturerModelForm = createSelector(
  [selectDomain],
  (manufacturerModelState) => manufacturerModelState.form
);
